import { Table } from 'antd';
import React, { useMemo } from 'react';

import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import { getColumns } from '../utils/getColumns';

export const AutoBroadcastsTable = ({
    source,
    loading,
    filters,
    updateFilters,
}) => {
    const pagination = useMemo(
        () =>
            dynamicPagination(
                filters,
                updateFilters,
                source?.total,
                'Рассылок'
            ),
        [filters, updateFilters, source?.total]
    );

    return (
        <Table
            rowKey={item => item.id}
            loading={loading}
            pagination={pagination}
            dataSource={source?.items}
            columns={getColumns()}
        />
    );
};
